import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Field,
  Rating,
  Text,
  Textarea,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import {
  FeedbackDialogProps,
  useFeedbackDialogViewModel,
} from "@onetasklist/shared";
import { useApi } from "@api/useApi";
import { useFeedbackDialogText } from "./FeedbackDialog.i18n";
import "./FeedbackDialog.scss";

const FeedbackDialog: React.FC<FeedbackDialogProps> = (props) => {
  const { t } = useTranslation();
  const texts = useFeedbackDialogText(t);
  const api = useApi();
  const vm = useFeedbackDialogViewModel({
    feedbackApi: api.feedback,
    boardId: props.boardId,
    isOpen: props.isOpen,
    onClose: () => props.onOpenChange(false),
    type: props.type,
  });

  const descriptionPlaceholder =
    props.type === "Source Suggestion"
      ? texts.sourceSuggestionDescriptionPlaceholder
      : texts.descriptionPlaceholder;

  return (
    <Dialog
      open={props.isOpen}
      onOpenChange={(_, data) => {
        props.onOpenChange(data.open);
      }}
    >
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{texts.title}</DialogTitle>

          <DialogContent className="feedback-dialog__content">
            <Field label={texts.ratingLabel}>
              <Rating
                value={vm.rating}
                onChange={(_, data) => vm.setRating(data.value)}
              />
            </Field>

            <Field label={texts.descriptionLabel}>
              <Textarea
                value={vm.description}
                onChange={(_, data) => vm.setDescription(data.value)}
                placeholder={descriptionPlaceholder}
                resize="vertical"
                rows={5}
              />
            </Field>

            {vm.hasError && (
              <Text className="feedback-dialog__error">
                {texts.errorMessage}
              </Text>
            )}
          </DialogContent>

          <DialogActions fluid>
            <Button appearance="secondary" onClick={vm.cancel}>
              {texts.cancelLabel}
            </Button>
            <Button
              appearance="primary"
              disabled={!vm.canSubmit}
              onClick={() => void vm.submit()}
            >
              {texts.submitLabel}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default FeedbackDialog;
